const isNullish = <T = unknown>(value: T | null | undefined): value is null | undefined =>
  value === null || value === undefined;

export default isNullish;
